import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ForgotpasswordComponent } from './forgotpassword/forgotpassword.component';
import { LoginComponent } from './login/login.component';
import { MainComponent } from './main/main.component';
import { ProjectselectComponent } from './projectselect/projectselect.component';
import { RegisterComponent } from './register/register.component';
import { LandscaperComponent } from './landscaper/landscaper.component';
import { PersonaMapperComponent } from './persona-mapper/persona-mapper.component';
import { DeepDiveComponent } from './deep-dive/deep-dive.component';
import { TestDesignerComponent } from './test-designer/test-designer.component';
import { InteractionMapperComponent } from './interaction-mapper/interaction-mapper.component';
import { TestExecutorComponent } from './test-executor/test-executor.component';
import { ScopeMapperComponent } from './scope-mapper/scope-mapper.component';
import { ChecklistComponent } from './checklist/checklist.component';
import { EnvironmentMapperComponent } from './environment-mapper/environment-mapper.component';
import { TestManagerComponent } from './test-manager/test-manager.component';
import { TaskPlannerComponent } from './task-planner/task-planner.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { CockpitReportComponent } from './cockpit-report/cockpit-report.component';
import { ExportReportComponent } from './export-report/export-report.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { MyNotesComponent } from './my-notes/my-notes.component';
import { ResetpasswordComponent } from './resetpassword/resetpassword.component';
import { ConfirmregisterComponent } from './confirmregister/confirmregister.component';
import { ConfirminviteComponent } from './confirminvite/confirminvite.component';
import { DashboardExecutionComponent } from './dashboard-execution/dashboard-execution.component';
import { DashboardQualityComponent } from './dashboard-quality/dashboard-quality.component';
import { JiraTestingComponent } from './jira-testing/jira-testing.component';
import { JiraUserStoriesComponent } from './jira-user-stories/jira-user-stories.component';
import { JiraBugsListComponent } from './jira-bugs-list/jira-bugs-list.component';
import { SprintPlannerComponent } from './sprint-planner/sprint-planner.component';
import { SprintPlannerPlusComponent } from './sprint-planner-plus/sprint-planner-plus.component';
import { InteractionMapperMindMapComponent } from './interaction-mapper-mind-map/interaction-mapper-mind-map.component';
import { PersonaMapperMindMapComponent } from './persona-mapper-mind-map/persona-mapper-mind-map.component';
import { ScopeMapperMindMapComponent } from './scope-mapper-mind-map/scope-mapper-mind-map.component';
import { JirabugsMapperComponent } from './jirabugs-mapper/jirabugs-mapper.component';
import { EntityTestComponent } from './entity-test/entity-test.component';
import { PersonaMapperEntityMindMapComponent } from './persona-mapper-entity-mind-map/persona-mapper-entity-mind-map.component';
import { ScopeMapperEntityMindMapComponent } from './scope-mapper-entity-mind-map/scope-mapper-entity-mind-map.component';
import { MindElixirMindmappingComponent } from './mind-elixir-mindmapping/mind-elixir-mindmapping.component';
import { ChatGptAssistantComponent } from './chat-gpt-assistant/chat-gpt-assistant.component';

const routes: Routes = [
  // {
  //   path: "admin", loadChildren: () => import('./app.module')
  //     .then(mod => mod.AppModule)
  // },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'register',
    component: RegisterComponent,
  },
  {
    path: 'confirmregister',
    component: ConfirmregisterComponent,
  },
  {
    path: 'confirminvite',
    component: ConfirminviteComponent,
  },
  {
    path: 'resetPassword',
    component: ResetpasswordComponent,
  },
  {
    path: 'forgotpassword',
    component: ForgotpasswordComponent,
  },
  {
    path: 'cockpitReport',
    component: CockpitReportComponent,
  },
  {
    path: 'exportReport',
    component: ExportReportComponent,
  },
  {
    path: 'jiraTesting',
    component: JiraTestingComponent,
  },
  {
    path: 'jiraUserStories',
    component: JiraUserStoriesComponent,
  },
  {
    path: 'jirabugslist',
    component: JiraBugsListComponent,
  },
  {
    path: 'main',
    component: MainComponent,
    children: [
      {
        path: '',
        redirectTo: 'projectselect',
        pathMatch: 'full',
      },
      {
        path: 'projectselect', // child route path
        component: ProjectselectComponent, // child route component that the router renders
      },
      {
        path: 'landscaper',
        component: LandscaperComponent, // another child route component that the router renders
      },
      {
        path: 'personaMapper',
        component: PersonaMapperComponent, // another child route component that the router renders
      },
      {
        path: 'personaMapperMindMap',
        component: PersonaMapperMindMapComponent, // another child route component that the router renders
      },
      {
        path: 'personaMapperEntityMindMap',
        component: PersonaMapperEntityMindMapComponent, // another child route component that the router renders
      },
      {
        path: 'interactionMapper',
        component: InteractionMapperComponent, // another child route component that the router renders
      },
      {
        path: 'interactionMapperMindMap',
        component: InteractionMapperMindMapComponent, // another child route component that the router renders
      },
      {
        path: 'scopeMapper',
        component: ScopeMapperComponent, // another child route component that the router renders
      },
      {
        path: 'scopeMapperMindMap',
        component: ScopeMapperMindMapComponent, // another child route component that the router renders
      },
      {
        path: 'scopeMapperEntityMindMap',
        component: ScopeMapperEntityMindMapComponent, // another child route component that the router renders
      },
      {
        path: 'environmentMapper',
        component: EnvironmentMapperComponent, // another child route component that the router renders
      },
      {
        path: 'taskPlanner',
        component: TaskPlannerComponent, // another child route component that the router renders
      },
      {
        path: 'mindMapping',
        component: MindElixirMindmappingComponent, // another child route component that the router renders
      },
      {
        path: 'sprintPlanner',
        component: SprintPlannerComponent, // another child route component that the router renders
        // children: [
        //   { path: ':step', component: SprintPlannerComponent },
        // ]
      },
      {
        path: 'sprintPlannerPlus',
        component: SprintPlannerPlusComponent, // another child route component that the router renders
        // children: [
        //   { path: ':step', component: SprintPlannerComponent },
        // ]
      },
      {
        path: 'jirabugsMapper',
        component: JirabugsMapperComponent, // another child route component that the router renders
      },
      {
        path: 'deepDive',
        component: DeepDiveComponent, // another child route component that the router renders
      },
      {
        path: 'testDesigner',
        component: TestDesignerComponent, // another child route component that the router renders
      },
      {
        path: 'checklist',
        component: ChecklistComponent, // another child route component that the router renders
      },
      {
        path: 'testExecutor',
        component: TestExecutorComponent, // another child route component that the router renders
      },
      {
        path: 'testManager',
        component: TestManagerComponent, // another child route component that the router renders
      },
      {
        path: 'dashboardTest',
        component: DashboardComponent, // another child route component that the router renders
      },
      {
        path: 'dashboardExecution',
        component: DashboardExecutionComponent, // another child route component that the router renders
      },
      {
        path: 'dashboardQuality',
        component: DashboardQualityComponent, // another child route component that the router renders
      },
      {
        path: 'notification',
        component: NotificationsComponent, // another child route component that the router renders
      },
      {
        path: 'mynotes',
        component: MyNotesComponent, // another child route component that the router renders
      },
      {
        path: 'chatGPTassist',
        component: ChatGptAssistantComponent, // another child route component that the router renders
      },
      {
        path: 'entityTest',
        component: EntityTestComponent, // another child route component that the router renders
      }
    ],
  },
  { path: "**", redirectTo: '/login' } // Wildcard route to handle un-matched url entered by user
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {
  static forRoot(routes: any, arg1: { onSameUrlNavigation: string; }): any[] | import("@angular/core").Type<any> {
    throw new Error('Method not implemented.');
  }
}
